"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var enums_1 = require("../../enums");

var utilities_1 = require("../../utilities");

var BulletPoint_1 = require("./BulletPoint");

var ElementContainer_1 = require("./ElementContainer");

var TextWithInheritedStyle_1 = require("./TextWithInheritedStyle");

var TextWithParsedStyles_1 = require("./TextWithParsedStyles");

exports.ElementWithParsedText = function (props) {
  var textContent = props.textContent,
      elementType = props.elementType,
      customBulletPointColor = props.customBulletPointColor;
  var parsedContent = utilities_1.parseTextStyle(textContent);
  var isListItem = elementType === enums_1.ElementsEnum.listItem;
  return react_1.default.createElement(TextWithInheritedStyle_1.TextWithInheritedStyle, null, react_1.default.createElement(ElementContainer_1.ElementContainer, {
    isListItem: isListItem
  }, utilities_1.elementChars[elementType] ? react_1.default.createElement(BulletPoint_1.BulletPoint, {
    color: customBulletPointColor
  }, utilities_1.elementChars[elementType] + " ") : null, parsedContent.map(function (textNode, index) {
    var textNodeContent = textNode.textContent,
        rest = __rest(textNode, ["textContent"]);

    return react_1.default.createElement(TextWithParsedStyles_1.TextWithParsedStyles, __assign({
      key: index
    }, rest), textNodeContent);
  })));
};